import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { formatViews } from "@/utils/movieHelpers";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col rounded-lg bg-background-50 border border-background-200 overflow-hidden transition-all duration-300 hover:border-primary-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={movie.title}
          title={`${movie.title} - 剧情解析与影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 rounded-md bg-primary-950/80 px-2 py-0.5 text-xs font-medium text-background-50">
          {movie.type === "movie" ? "电影" : "电视剧"}
        </span>
        <span className="absolute bottom-2 right-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-50">
          <i className="ri-star-fill text-xs" />
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-col gap-2 p-3 md:p-4">
        <h3 className="text-sm md:text-base font-medium text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-500">
          {movie.year} · {movie.region} · {movie.duration}
        </p>
        <div className="flex flex-wrap gap-1.5">
          {movie.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
        <p className="text-xs text-foreground-400">
          <i className="ri-eye-line mr-1" />
          {formatViews(movie.views)} 次浏览
        </p>
      </div>
    </Link>
  );
}